module.exports = __webpack_public_path__ + "static/media/page05_man_boy.9e0c248c.png";